import {
	buildGoodsFixedPriceChannelSavePayload,
	buildGoodsSafetyStockPriceSavePayload,
	buildFixedPriceChannelSavePayload,
	buildSafetyStockPriceSavePayload,
	fetchGoodsPushConfig,
	fetchPushConfig,
	mapFixedPriceChannelConfigToForm,
	mapManualConfigToForm,
	mapSafetyStockPriceConfigToForm,
	PUSH_CONFIG_TYPES,
	saveGoodsPushConfig,
	savePushConfig,
} from './retailShopPushConfig'

function normalizeData(responseData) {
	if (!responseData) {
		return {}
	}
	if (responseData.data && typeof responseData.data === 'object' && !Array.isArray(responseData.data)) {
		return responseData.data
	}
	return responseData
}

function mapSizeColumn(size) {
	return {
		id: size.id || size.size_id || size.sku_id,
		size: size.size || size.name || '',
		size_key: size.size_key != null ? size.size_key : '',
	}
}

function getSummarySizeValue(source, sizeId) {
	if (!source || sizeId == null) {
		return undefined
	}
	const id = String(sizeId)
	const keys = ['size_' + id, id]
	let i
	for (i = 0; i < keys.length; i++) {
		if (source[keys[i]] != null && source[keys[i]] !== '') {
			return source[keys[i]]
		}
	}
	if (source.sizes && source.sizes[sizeId] != null && source.sizes[sizeId] !== '') {
		return source.sizes[sizeId]
	}
	if (source.sizes && source.sizes[id] != null && source.sizes[id] !== '') {
		return source.sizes[id]
	}
	return undefined
}

function getSummarySizeSelectValue(source, sizeId) {
	if (!source || sizeId == null) {
		return undefined
	}
	const id = String(sizeId)
	const keys = ['size_' + id + '_select', id + '_select']
	let i
	for (i = 0; i < keys.length; i++) {
		if (source[keys[i]] != null) {
			return source[keys[i]]
		}
	}
	if (source.sizes) {
		if (source.sizes['size_' + id + '_select'] != null) {
			return source.sizes['size_' + id + '_select']
		}
		if (source.sizes[id + '_select'] != null) {
			return source.sizes[id + '_select']
		}
	}
	return undefined
}

function enrichSummarySection(section, sizes, field) {
	const result = section && typeof section === 'object' ? Object.assign({}, section) : {}
	let hasValue = false
	let i
	for (i = 0; i < sizes.length; i++) {
		const size = sizes[i]
		if (getSummarySizeValue(result, size.id) != null) {
			hasValue = true
			continue
		}
		const pddPrice = size.pdd_price || size.prices || size.price_info || {}
		const value = pddPrice[field] != null ? pddPrice[field] : size[field]
		if (value != null && value !== '') {
			result['size_' + size.id] = value
			hasValue = true
		}
	}
	return hasValue ? result : null
}

function normalizeCompareSummary(sizes, summary) {
	const src = summary && typeof summary === 'object' ? summary : {}
	const normalized = {}
	const defs = [
		'safety_stock',
		'safety_discount',
		'single_price',
		'group_price',
		'max_agent_price',
	]
	let i
	for (i = 0; i < defs.length; i++) {
		const key = defs[i]
		const section = enrichSummarySection(src[key], sizes, key) || src[key]
		if (section && typeof section === 'object' && Object.keys(section).length) {
			normalized[key] = section
		}
	}
	return normalized
}

function mapChannelRow(row, sizes) {
	const mapped = Object.assign({}, row)
	let i
	for (i = 0; i < sizes.length; i++) {
		const size = sizes[i]
		const key = 'size_' + size.id
		const selectKey = key + '_select'
		if (mapped[key] == null && row.sizes && row.sizes[size.id] != null) {
			mapped[key] = row.sizes[size.id]
		}
		if (mapped[selectKey] == null && row.sizes) {
			if (row.sizes[selectKey] != null) {
				mapped[selectKey] = row.sizes[selectKey]
			} else if (row.sizes[size.id + '_select'] != null) {
				mapped[selectKey] = row.sizes[size.id + '_select']
			}
		}
	}
	return mapped
}

const SUMMARY_ROW_LABELS = {
	safety_stock: '安全库存',
	safety_discount: '安全折扣',
	single_price: '单买价',
	group_price: '拼团价',
	max_agent_price: '最高代理价',
}

export function resolveSummaryRowTypes(syncRule) {
	if (syncRule === 'manual') {
		return ['single_price', 'group_price']
	}
	if (syncRule === 'fixed_price_channel_shop' || syncRule === 'fixed_price_channel_product') {
		return ['single_price', 'group_price', 'max_agent_price']
	}
	if (syncRule === 'safety_stock_price_shop') {
		return ['safety_discount', 'single_price', 'group_price', 'max_agent_price']
	}
	if (syncRule === 'safety_stock_price_product') {
		return ['safety_stock', 'safety_discount', 'single_price', 'group_price', 'max_agent_price']
	}
	return []
}

function buildSummaryRows(sizes, summary, syncRule) {
	if (!sizes.length || !summary) {
		return []
	}
	const normalizedSummary = normalizeCompareSummary(sizes, summary)
	const rowTypes = resolveSummaryRowTypes(syncRule)
	const rows = []
	let i
	let j
	for (i = 0; i < rowTypes.length; i++) {
		const key = rowTypes[i]
		const source = normalizedSummary[key]
		if (!source) {
			continue
		}
		const row = { shop_name: SUMMARY_ROW_LABELS[key] || key, _summary: true, _rowType: key }
		let hasCell = false
		for (j = 0; j < sizes.length; j++) {
			const size = sizes[j]
			const cellKey = 'size_' + size.id
			const selectKey = cellKey + '_select'
			const value = getSummarySizeValue(source, size.id)
			if (value == null || value === '') {
				continue
			}
			row[cellKey] = value
			hasCell = true
			const selectValue = getSummarySizeSelectValue(source, size.id)
			row[selectKey] = selectValue != null ? selectValue : 1
		}
		if (hasCell) {
			rows.push(row)
		}
	}
	return rows
}

export function resolvePushConfigApiType(syncRule) {
	if (!syncRule || syncRule === 'none') {
		return 'none'
	}
	if (syncRule === 'manual') {
		return PUSH_CONFIG_TYPES.MANUAL
	}
	if (syncRule === 'fixed_price_channel_shop' || syncRule === 'fixed_price_channel_product') {
		return PUSH_CONFIG_TYPES.FIXED_PRICE_CHANNEL
	}
	if (syncRule === 'safety_stock_price_shop' || syncRule === 'safety_stock_price_product') {
		return PUSH_CONFIG_TYPES.SAFETY_STOCK_PRICE
	}
	return 'none'
}

export function isProductPushConfigScope(syncRule) {
	return syncRule === 'fixed_price_channel_product' || syncRule === 'safety_stock_price_product'
}

export function isShopPushConfigScope(syncRule) {
	return syncRule === 'fixed_price_channel_shop' || syncRule === 'safety_stock_price_shop'
}

export function isShopSharedConfigReadonly(syncRule) {
	return syncRule === 'fixed_price_channel_shop' || syncRule === 'safety_stock_price_shop'
}

function applySafetyStockProductFields(form, src) {
	const config = src.config && typeof src.config === 'object' ? src.config : src
	if (config.safety_discount != null && config.safety_discount !== '') {
		form.safetyDiscount = Number(config.safety_discount)
	} else if (src.safety_discount != null && src.safety_discount !== '') {
		form.safetyDiscount = Number(src.safety_discount)
	}
	if (form.singleBuyMarkup == null && config.price_add != null) {
		form.singleBuyMarkup = Number(config.price_add)
	}
	return form
}

export function mapPushConfigToForm(syncRule, data, createTierRow, minTierCount) {
	const apiType = resolvePushConfigApiType(syncRule)
	let form = {}
	let stockCategories = []

	if (apiType === 'none') {
		return { form: form, stockCategories: stockCategories }
	}
	if (apiType === PUSH_CONFIG_TYPES.MANUAL) {
		const manual = mapManualConfigToForm(data)
		form = {
			shipDays: manual.pre_delivery_date,
		}
		return { form: form, stockCategories: stockCategories }
	}
	if (apiType === PUSH_CONFIG_TYPES.SAFETY_STOCK_PRICE) {
		const mapped = mapSafetyStockPriceConfigToForm(data, createTierRow, minTierCount)
		form = mapped.form
		stockCategories = mapped.stockCategories
		if (syncRule === 'safety_stock_price_product') {
			form = applySafetyStockProductFields(form, data)
		}
		return { form: form, stockCategories: stockCategories }
	}
	if (apiType === PUSH_CONFIG_TYPES.FIXED_PRICE_CHANNEL) {
		form = mapFixedPriceChannelConfigToForm(data, createTierRow, minTierCount)
		return { form: form, stockCategories: stockCategories }
	}
	return { form: form, stockCategories: stockCategories }
}

export function fetchChannelPushConfig(axios, syncRule, productId, shopId) {
	const type = resolvePushConfigApiType(syncRule)
	if (isProductPushConfigScope(syncRule)) {
		if (!productId) {
			return Promise.reject(new Error('商品信息不完整'))
		}
		return fetchGoodsPushConfig(axios, Number(productId), type)
	}
	if (!shopId) {
		return Promise.reject(new Error('店铺信息不完整'))
	}
	return fetchPushConfig(axios, Number(shopId), type)
}

export function mapChannelTableData(data, syncRule) {
	const src = normalizeData(data)
	const items = Array.isArray(src.items) ? src.items : (Array.isArray(src.products) ? src.products : [])
	const channelBlocks = []

	items.forEach(function(item) {
		const compare = item.compare_price || item.channel_compare || {}
		const sizes = Array.isArray(compare.sizes) ? compare.sizes.map(mapSizeColumn) : []
		const list = Array.isArray(compare.list) ? compare.list.map(function(row) {
			return mapChannelRow(row, sizes)
		}) : []
		const summaryRows = buildSummaryRows(sizes, compare.summary || compare.price_summary, syncRule)
		const tablelist = summaryRows.concat(list)
		if (!tablelist.length && !sizes.length) {
			return
		}
		channelBlocks.push({
			product: item.product || item.goods || {},
			sizes: sizes,
			tablelist: tablelist,
		})
	})

	if (!channelBlocks.length && (src.compare_price || src.channels)) {
		const compare = src.compare_price || { list: src.channels, sizes: src.sizes || [] }
		const sizes = Array.isArray(compare.sizes) ? compare.sizes.map(mapSizeColumn) : []
		const list = Array.isArray(compare.list) ? compare.list.map(function(row) {
			return mapChannelRow(row, sizes)
		}) : []
		channelBlocks.push({
			product: src.product || {},
			sizes: sizes,
			tablelist: buildSummaryRows(sizes, compare.summary, syncRule).concat(list),
		})
	}

	return {
		channelBlocks: channelBlocks,
	}
}

export function mapChannelConfigResponse(data, createTierRow, minTierCount, syncRule) {
	const rule = syncRule || 'none'
	const pushMapped = mapPushConfigToForm(rule, data, createTierRow, minTierCount)
	const tableMapped = mapChannelTableData(data, rule)
	return {
		syncRule: rule,
		form: pushMapped.form,
		stockCategories: pushMapped.stockCategories,
		channelBlocks: tableMapped.channelBlocks,
	}
}

export function resolvePushConfigType(syncRule) {
	return resolvePushConfigApiType(syncRule)
}

function normalizeManualPrice(value) {
	if (value == null || value === '') {
		return 0
	}
	return Number(value)
}

function resolveChannelRowShopId(row) {
	if (row.shop_id != null && row.shop_id !== '') {
		return row.shop_id
	}
	return null
}

export function buildManualSavePayload(productId, channelBlocks) {
	const payload = {
		retail_shop_product_id: Number(productId),
		sku_prices: [],
		sku_shop_bindings: [],
	}
	if (!channelBlocks || !channelBlocks.length) {
		return payload
	}
	channelBlocks.forEach(function(block) {
		const sizes = block.sizes || []
		const tablelist = block.tablelist || []
		const singleRow = findSummaryRowByType(tablelist, 'single_price')
		const groupRow = findSummaryRowByType(tablelist, 'group_price')
		sizes.forEach(function(size) {
			const sizeKey = 'size_' + size.id
			payload.sku_prices.push({
				id: size.id,
				price: normalizeManualPrice(singleRow ? singleRow[sizeKey] : undefined),
				multi_price: normalizeManualPrice(groupRow ? groupRow[sizeKey] : undefined),
			})
		})
		tablelist.forEach(function(row) {
			if (!row || row._summary || row._legend) {
				return
			}
			const shopId = resolveChannelRowShopId(row)
			if (shopId == null || shopId === '') {
				return
			}
			sizes.forEach(function(size) {
				const selectKey = 'size_' + size.id + '_select'
				if (row[selectKey] == 1) {
					payload.sku_shop_bindings.push({
						retail_shop_product_sku_id: stripSizePrefix('size_' + size.id),
						user_shop_id: Number(shopId),
					})
				}
			})
		})
	})
	return payload
}

export function saveManualChannelConfig(axios, payload) {
	return axios.post('api/retail_goods/manual_save', payload).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '保存失败')
		}
		return res.data
	})
}

export function buildChannelConfigSavePayload(productId, shopId, syncRule, form, stockCategories, channelBlocks) {
	if (isManualChannelRule(syncRule)) {
		return {
			scope: 'manual',
			payload: buildManualSavePayload(productId, channelBlocks),
		}
	}
	const apiType = resolvePushConfigApiType(syncRule)
	if (apiType === PUSH_CONFIG_TYPES.SAFETY_STOCK_PRICE) {
		if (isProductPushConfigScope(syncRule)) {
			const payload = buildGoodsSafetyStockPriceSavePayload(productId, form, stockCategories)
			delete payload.data.safety_stocks
			payload.data.price_add = form.singleBuyMarkup != null ? Number(form.singleBuyMarkup) : 0
			payload.data.safety_discount = form.safetyDiscount != null ? Number(form.safetyDiscount) : 10
			payload.data.sku_stocks = buildMatchSkuPrices(channelBlocks, null, syncRule)
			return { scope: 'product', payload: payload }
		}
		return {
			scope: 'shop',
			payload: buildSafetyStockPriceSavePayload(shopId, form, stockCategories),
		}
	}
	if (apiType === PUSH_CONFIG_TYPES.FIXED_PRICE_CHANNEL) {
		if (isProductPushConfigScope(syncRule)) {
			return {
				scope: 'product',
				payload: buildGoodsFixedPriceChannelSavePayload(productId, form),
			}
		}
		return {
			scope: 'shop',
			payload: buildFixedPriceChannelSavePayload(shopId, form),
		}
	}
	return {
		scope: 'product',
		payload: {
			retail_shop_product_id: Number(productId),
			sync_rule: syncRule,
			data: form,
		},
	}
}

export function saveChannelPushConfig(axios, saveResult) {
	if (saveResult.scope === 'shop') {
		return savePushConfig(axios, saveResult.payload)
	}
	if (saveResult.scope === 'manual') {
		return saveManualChannelConfig(axios, saveResult.payload)
	}
	return saveGoodsPushConfig(axios, saveResult.payload)
}

export function isFixedPriceChannelRule(syncRule) {
	return syncRule === 'fixed_price_channel_shop' || syncRule === 'fixed_price_channel_product'
}

export function isSafetyStockPriceChannelRule(syncRule) {
	return syncRule === 'safety_stock_price_shop' || syncRule === 'safety_stock_price_product'
}

export function isConfigSourceChannelMatchRule(syncRule) {
	return isFixedPriceChannelRule(syncRule) || isSafetyStockPriceChannelRule(syncRule)
}

export function isManualChannelRule(syncRule) {
	return syncRule === 'manual'
}

function resolveChannelMatchApi(syncRule) {
	if (isManualChannelRule(syncRule)) {
		return 'api/retail_goods/manual_channel_match'
	}
	if (isFixedPriceChannelRule(syncRule)) {
		return 'api/retail_goods/fixed_price_channel_match'
	}
	if (isSafetyStockPriceChannelRule(syncRule)) {
		return 'api/retail_goods/safety_stock_price_channel_match'
	}
	return 'api/retail_goods/channel_match'
}

function isSizeSummaryKey(key) {
	return key.indexOf('size_') === 0 && key.indexOf('_select') === -1
}

function stripSizePrefix(key) {
	const normalized = String(key)
	if (normalized.indexOf('size_') === 0) {
		return normalized.slice(5)
	}
	return normalized
}

function findSummaryRowByType(tablelist, rowType) {
	return (tablelist || []).find(function(row) {
		return row && row._summary && row._rowType === rowType
	})
}

function resolveRawSummarySection(rawSummaryData, syncRule) {
	if (!rawSummaryData || typeof rawSummaryData !== 'object') {
		return null
	}
	if (syncRule === 'safety_stock_price_product') {
		return rawSummaryData.safety_stock || rawSummaryData
	}
	return rawSummaryData.group_price || rawSummaryData
}

function buildSkuPricesFromRawSummary(rawSummaryData, syncRule) {
	const section = resolveRawSummarySection(rawSummaryData, syncRule)
	const skuPrices = []
	if (!section || typeof section !== 'object') {
		return skuPrices
	}
	const isSafetyStockProduct = syncRule === 'safety_stock_price_product'
	Object.keys(section).forEach(function(key) {
		if (!isSizeSummaryKey(key)) {
			return
		}
		const value = section[key]
		if (value == null || value === '') {
			return
		}
		if (isSafetyStockProduct) {
			skuPrices.push({
				id: stripSizePrefix(key),
				safety_stock: Number(value),
			})
			return
		}
		skuPrices.push({
			sku_id: stripSizePrefix(key),
			multi_price: Number(value),
		})
	})
	return skuPrices
}

export function buildMatchSkuPrices(channelBlocks, rawSummaryData, syncRule) {
	const isSafetyStockProduct = syncRule === 'safety_stock_price_product'
	const summaryRowType = isSafetyStockProduct ? 'safety_stock' : 'group_price'
	const skuPrices = []
	const seen = {}

	function upsertEntry(rawKey, value) {
		if (rawKey == null || rawKey === '' || value == null || value === '') {
			return
		}
		const dedupeKey = stripSizePrefix(String(rawKey))
		let entry
		if (isSafetyStockProduct) {
			entry = {
				id: dedupeKey,
				safety_stock: Number(value),
			}
		} else {
			entry = {
				sku_id: dedupeKey,
				multi_price: Number(value),
			}
		}
		const existingIndex = skuPrices.findIndex(function(item) {
			const itemKey = isSafetyStockProduct ? item.id : item.sku_id
			return String(itemKey) === dedupeKey
		})
		if (existingIndex >= 0) {
			skuPrices[existingIndex] = entry
		} else {
			skuPrices.push(entry)
		}
		seen[dedupeKey] = true
	}

	;(channelBlocks || []).forEach(function(block) {
		const summaryRow = findSummaryRowByType(block.tablelist, summaryRowType)
		if (!summaryRow) {
			return
		}
		if (Array.isArray(block.sizes) && block.sizes.length) {
			block.sizes.forEach(function(size) {
				const summaryKey = 'size_' + size.id
				upsertEntry(summaryKey, summaryRow[summaryKey])
			})
			return
		}
		Object.keys(summaryRow).forEach(function(key) {
			if (!isSizeSummaryKey(key)) {
				return
			}
			upsertEntry(key, summaryRow[key])
		})
	})

	buildSkuPricesFromRawSummary(rawSummaryData, syncRule).forEach(function(item) {
		const dedupeKey = isSafetyStockProduct ? String(item.id) : String(item.sku_id)
		if (seen[dedupeKey]) {
			return
		}
		skuPrices.push(item)
		seen[dedupeKey] = true
	})

	return skuPrices
}

export function buildMatchPushConfig(syncRule, form) {
	const data = buildFixedPriceChannelSavePayload(0, form || {}).data
	const pushConfig = {
		min_profit_margin: data.min_profit_margin,
		no_return_markup: data.no_return_markup,
		deduction_rate: data.deduction_rate,
		shipping_fee: data.shipping_fee,
		return_policy: data.return_policy,
		no_return_discount_threshold: data.no_return_discount_threshold,
		allocation_rate_min: data.allocation_rate_min,
		on_time_rate_min: data.on_time_rate_min,
		pre_delivery_date: data.pre_delivery_date,
		anti_fake_status: data.anti_fake_status,
		channel_scope: data.channel_scope,
		profit_tiers: data.profit_tiers,
	}
	if (syncRule === 'safety_stock_price_product') {
		pushConfig.price_add = form.singleBuyMarkup != null ? Number(form.singleBuyMarkup) : 0
		pushConfig.safety_discount = form.safetyDiscount != null ? Number(form.safetyDiscount) : 10
	}
	return pushConfig
}

export function matchGoodsChannelsByRule(axios, productId, syncRule, matchOptions) {
	if (!productId) {
		return Promise.reject(new Error('商品信息不完整'))
	}
	const options = matchOptions || {}
	const payload = {
		retail_shop_product_id: Number(productId),
	}
	const url = resolveChannelMatchApi(syncRule)
	if (isConfigSourceChannelMatchRule(syncRule)) {
		payload.config_source = syncRule
		if (options.withMatchParams) {
			if (options.form) {
				payload.push_config = buildMatchPushConfig(syncRule, options.form)
			}
			const skuStockData = buildMatchSkuPrices(options.channelBlocks, options.rawSummaryData, syncRule)
			if (syncRule === 'safety_stock_price_product') {
				payload.sku_stocks = skuStockData
			} else {
				payload.sku_prices = skuStockData
			}
		}
	} else if (!isManualChannelRule(syncRule)) {
		payload.sync_rule = syncRule
	}
	return axios.post(url, payload).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '匹配渠道失败')
		}
		return res.data.data
	})
}

export function saveGoodsSyncRule(axios, productId, syncRule) {
	return axios.post('api/retail_shop/product_push_strategy_save', {
		id: Number(productId),
		push_strategy: syncRule,
	}).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '更新同步规则失败')
		}
		return res.data
	})
}



// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/retailGoodsChannelConfig.js